module.exports = __webpack_public_path__ + "static/media/handshake-simple-solid.07ed1717.svg";